import React,{useState,useEffect} from 'react'
import './CauseCard.css'
import Button from '../button/Button'
import { images } from '../../assets'

function CauseCard({ onInterestClick }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

  return (
    <div className='causeCard'>
        <div className='causeCardContent'>
            <div className='causePoints'>
            <div className='causeCardTitle'>FREE for 3 Months</div>
            <div className='points'>
              <div className='pointsLine'>
                <div className='point'>
                  <img src={images.one} alt="Point" />
                </div>
                <div className='pointText'>Showcase your upcoming CSR projects on the app or choose from impacts Non-Profits to fund</div>
              </div>
              <div className='pointsLine'>
                <div className='point'>
                  <img src={images.two} alt="Point" />
                </div>
                <div className='pointText'>Community will walk for your projects every day</div>
              </div>
              <div className='pointsLine'>
                <div className='point'>
                  <img src={images.three} alt="Point" />
                </div>
                <div className='pointText'>Redirect them to increase traffic on your website, CSR pages or social media pages</div>
              </div>
              <div className='pointsLine'>
                <div className='point'>
                  <img src={images.four} alt="Point" />
                </div>
                <div className='pointText'>Get quaterly report with community engagement metric</div>
              </div>
            </div>
            <Button onClick={onInterestClick} buttonText={windowWidth <= 426 ?  "Request a call back":"I am interested"}  className="custom-button" arrowClassName="custom-arrow" />

            </div>
            <img className='causeCardPhoto' src={images.causeCard} alt='causePhoto' />
        </div>
    </div>
  )
}

export default CauseCard
